interface BlockHeaderProps {
  title: string;
}

const BlockHeader = ({ title }: BlockHeaderProps): React.JSX.Element => (
  <h4 className="font-semibold text-gray-700 mb-1">{title}</h4>
);

export default BlockHeader;
